import {
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  startAfter,
  where,
} from "firebase/firestore";
import React, { useEffect, useState, useRef } from "react";
import { toast } from "react-toastify";
import { db } from "../firebase.js";
import "./Offers.scss";


import NewPatientModal from './NewPatientModal.jsx.jsx'
import { Button } from 'react-bootstrap';
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import HolidayVillageIcon from '@mui/icons-material/HolidayVillage';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import GridViewRoundedIcon from "@mui/icons-material/GridViewRounded";
import ReceiptRoundedIcon from "@mui/icons-material/ReceiptRounded";
import BarChartRoundedIcon from "@mui/icons-material/BarChartRounded";
import TimelineRoundedIcon from "@mui/icons-material/TimelineRounded";
import BubbleChartRoundedIcon from "@mui/icons-material/BubbleChartRounded";
import WalletRoundedIcon from "@mui/icons-material/WalletRounded";
import AccountBalanceRoundedIcon from "@mui/icons-material/AccountBalanceRounded";
import SavingsRoundedIcon from "@mui/icons-material/SavingsRounded";
import MonetizationOnRoundedIcon from "@mui/icons-material/MonetizationOnRounded";
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import ShieldRoundedIcon from "@mui/icons-material/ShieldRounded";
import HouseIcon from '@mui/icons-material/House';
import GppGoodIcon from '@mui/icons-material/GppGood';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import NotificationsRoundedIcon from "@mui/icons-material/NotificationsRounded";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PieChartIcon from '@mui/icons-material/PieChart';
import SearchIcon from '@mui/icons-material/Search';
import CalculateIcon from '@mui/icons-material/Calculate';
import AddHomeIcon from '@mui/icons-material/AddHome';
import SchoolIcon from '@mui/icons-material/School';
import GroupIcon from '@mui/icons-material/Group';

const Loans = () => {
  const [listings, setListings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [lastFetchedListing, setLastFetchListing] = useState(null);
  const embedContainerRef = useRef(null);

//   useEffect(() => {
//     if (embedContainerRef.current) {
//       const embedManager = new QualifiedEmbedManager();
//       embedManager.embed({
//         container: embedContainerRef.current,
//         key: "https://fs4.formsite.com/res/showFormEmbed?EParam=PyBo85CFjhErPGdGVukEhj4v0rcqjgM7&1251792926",
// width: "100%"
//         // ... other embed options 
//       });
//     }
//   }, []);
  

  // function openLogin() {
  //   EmbedManager.embed({
  //     key: "https://fs4.formsite.com/res/showFormEmbed?EParam=PyBo85CFjhErPGdGVukEhj4v0rcqjgM7&1251792926",
  //     width: "100%"
  //     });
  //   }

  const scriptInjection = `
  <a name="form1251792926" id="formAnchor1251792926"></a>
<script src="https://fs4.formsite.com/include/form/embedManager.js?1251792926"></script>
<script>
EmbedManager.embed({
key: "https://fs4.formsite.com/res/showFormEmbed?EParam=PyBo85CFjhErPGdGVukEhj4v0rcqjgM7&1251792926",
width: "100%"
});
</script>
  
  `

  const OpenModalButton = () => {
    const [open, setOpen] = React.useState(false);
  
    const handleOpen = () => {
      setOpen(true);
    };
  
    const handleClose = () => {
      setOpen(false);
    };
  
    
  
    return (
      <>
        <Button variant="primary" onClick={handleOpen} color="primary" >Open Modal</Button>
        <NewPatientModal
          open={open}
          onOpen={handleOpen}
          onClose={handleClose}
        />
      </>
    );
  };





  
  const rawHTML = `
  <div class="dropdown">
    <button class="btn btn-default dropdown-toggle" type="button" id="dropdownMenu1" data-toggle="dropdown" aria-expanded="true">
      Dropdown
      <span class="caret"></span>
    </button>
    <ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu1">
      <li role="presentation"><a role="menuitem" tabindex="-1" href="#">Action</a></li>
      <li role="presentation"><a role="menuitem" tabindex="-1" href="#">Another action</a></li>
      <li role="presentation"><a role="menuitem" tabindex="-1" href="#">Something else here</a></li>
      <li role="presentation"><a role="menuitem" tabindex="-1" href="#">Separated link</a></li>
    </ul>
  </div> `
  

  return (
    <div className="offer" >
      <h1 className="offer__title">Loans</h1>
      
    { <div dangerouslySetInnerHTML={{ __html:scriptInjection }} /> }


      {/* <OpenModalButton/> */}

      <div style={{ display: "flex", height: "100vh"}}>
      <Sidebar style={{ backgroundColor: 'white '}}>
        <Menu style={{ backgroundColor: 'white'}}>
          <MenuItem >
          <div style={{marginLeft:-43}}>
          <img
            src="https://i.ibb.co/s2dBvDt/elevate.png"
            alt="logo"
            
            width={300}
          ></img>
          </div>
          </MenuItem>
          
          <SubMenu label="Deal Finder" icon={<HolidayVillageIcon />}>
            <MenuItem icon={<LocationOnIcon />}> FMR Explorer </MenuItem>
            <MenuItem icon={<PieChartIcon />}>City Research</MenuItem>
            <MenuItem icon={<SearchIcon />}>Property Lookup</MenuItem>
            <MenuItem icon={<CalculateIcon />}>Deal Calculator</MenuItem>
            <MenuItem icon={<AddHomeIcon />}>Deal Explorer</MenuItem>
          </SubMenu>
          <SubMenu label="              Real Estate Courses" icon={<SchoolIcon />}>
            <MenuItem icon={<AccountBalanceRoundedIcon />}>
              Elevate with Section Eight
            </MenuItem>
          </SubMenu>
          <div>
    { <div dangerouslySetInnerHTML={{ __html:scriptInjection }} /> }
  </div>
          {/* <MenuItem icon={<GroupIcon />}>Tenant Finder</MenuItem> */}
          <SubMenu label="Tenant Hub" style={{ backgroundColor: 'white'}} icon={<GroupIcon />}>
            <MenuItem icon={<HouseIcon />}> Housing Authority DIrectory </MenuItem>
            <MenuItem icon={<EmojiPeopleIcon />}> Tenant Lookup </MenuItem>
           
          </SubMenu>
          <SubMenu label="Elevate Financial" style={{ backgroundColor: 'white'}} icon={<AttachMoneyIcon />}>
            <MenuItem icon={<CurrencyExchangeIcon />}> Loan Portal </MenuItem>
            <MenuItem icon={<GppGoodIcon />}> Landlord Insurance </MenuItem>
           
          </SubMenu>
          <SubMenu label="Settings" style={{ backgroundColor: 'white'}} icon={<SettingsSuggestIcon />}>
            <MenuItem icon={<AccountCircleRoundedIcon />}> Account </MenuItem>
            <MenuItem icon={<ShieldRoundedIcon />}> <OpenModalButton/> </MenuItem>
            <MenuItem icon={<NotificationsRoundedIcon />}>
              Notifications
            </MenuItem>
          </SubMenu>
          <MenuItem icon={<LogoutRoundedIcon />}> Logout </MenuItem>
        </Menu>
      </Sidebar>
      {/* <div dangerouslySetInnerHTML={{__html: scriptInjection}}></div> */}
      {/* <Helmet>
                <a name="form1251792926" id="formAnchor1251792926"></a>
          <script src="https://fs4.formsite.com/include/form/embedManager.js?1251792926"></script>
          <script>
          EmbedManager.embed({{
          key: "https://fs4.formsite.com/res/showFormEmbed?EParam=PyBo85CFjhErPGdGVukEhj4v0rcqjgM7&1251792926",
          width: "100%"
          }});
          </script>
            </Helmet> */}




      
    
 

   
    </div>
    </div>
    
  );
};

export default Loans;
